/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
import { CompetenciaInput, DateInput, NumberInput, ReadOnlyInput, TextInput, TextLabel } from '@core/components/Inputs';
import { useApiUtils } from '@core/util/apiUtils';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { InputMonetario } from 'app/components/Input';
import SelectClienteCreatable from 'app/components/Select/SelectClienteCreatable';
import SelectConta from 'app/components/Select/SelectConta';
import { ListaDeOcorrencia } from 'app/main/contaspagar/components';
import contaReceberApi from 'app/services/api/contaReceberApi';
import * as Actions from 'app/store/actions';
import { getCurrency } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ContaReceberContext } from '../contaReceberContext';
import ContaReceberAcrescimosDescontos from './ContaReceberAcrescimosDescontos';
import ContaReceberRecebimentosRealizados from './ContaReceberRecebimentosRealizados';
import ContasReceberCategorias from './ContasReceberCategorias';

const ORIGENS_LANCAMENTO = {
  CONTA_RECEBER: 'Conta a receber',
  CONTRATO: 'Contratos',
  VENDA: 'Vendas',
  CONCILIACAO: 'Conciliação bancária',
  VENDA_CONTRATO: 'Venda e contrato',
};

const onlyNumberRegex = /^\d*$/;

const HintTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: 180,
  },
}))(Tooltip);

const ContaReceberForm = ({ origemConciliacao = false }) => {
  const formik = useFormikContext();

  const [, setLoading] = useContext(ContaReceberContext).loading;
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const disabledSeForOrigemContrato =
    formik.values?.origemLancamento === 'CONTRATO' || formik.values?.origemLancamento === 'VENDA_CONTRATO';

  const disabledSeForOrigemVenda =
    formik.values?.origemLancamento === 'VENDA' || formik.values?.origemLancamento === 'VENDA_CONTRATO';

  const disabledSeTiverNotaFiscalId = !!formik.values?.notaFiscalId;

  const repetirLancamento = formik.values?.id
    ? formik.values?.recorrencia?.frequencia && formik.values?.recorrencia?.quantidade
    : formik.values?.repetirLancamento;

  const isNovoCadastro = !formik.values?.id;

  const disabledSubJudice = !isNovoCadastro && formik.values?.subJudice;

  const disabledSeForBaixaParcial = formik.values?.situacao === 'PARCIAL';

  const sizes = {
    competencia: { xs: 12, sm: 2, md: 2, lg: 2, xl: 2 },
    cliente: {
      xs: 12,
      sm: isNovoCadastro ? 10 : 8,
      md: isNovoCadastro ? 10 : 8,
      lg: isNovoCadastro ? 10 : 8,
      xl: isNovoCadastro ? 10 : 8,
    },
    origem: {
      xs: 12,
      sm: isNovoCadastro ? 0 : 2,
      md: isNovoCadastro ? 0 : 2,
      lg: isNovoCadastro ? 0 : 2,
      xl: isNovoCadastro ? 0 : 2,
    },
  };

  const _errors = {
    mesCompetencia: (formik.touched?.mesCompetencia || formik.submitCount > 0) && formik.errors?.mesCompetencia,
    cliente: (formik.touched?.cliente || formik.submitCount > 0) && formik.errors?.cliente,
    dataVencimento: (formik.touched?.dataVencimento || formik.submitCount > 0) && formik.errors?.dataVencimento,
    dataEmissao: (formik.touched?.dataEmissao || formik.submitCount > 0) && formik.errors?.dataEmissao,
    conta: (formik.touched?.conta || formik.submitCount > 0) && formik.errors?.conta,
    baixa: {
      dataRecebimento:
        (formik.touched?.baixa?.dataRecebimento || formik.submitCount > 0) && formik.errors?.baixa?.dataRecebimento,
      dataLiquidacao:
        (formik.touched?.baixa?.dataLiquidacao || formik.submitCount > 0) && formik.errors?.baixa?.dataLiquidacao,
      formaRecebimento:
        (formik.touched?.baixa?.formaRecebimento || formik.submitCount > 0) && formik.errors?.baixa?.formaRecebimento,
      valorRecebido:
        (formik.touched?.baixa?.valorRecebido || formik.submitCount > 0) && formik.errors?.baixa?.valorRecebido,
    },
    recorrencia: {
      frequencia:
        (formik.touched?.recorrencia?.frequencia || formik.submitCount > 0) && formik.errors?.recorrencia?.frequencia,
      quantidade:
        (formik.touched?.recorrencia?.quantidade || formik.submitCount > 0) && formik.errors?.recorrencia?.quantidade,
    },
  };

  const nossoNumero = formik.values?.receitaCobranca?.nossoNumero || formik.values?.nossoNumeroAntigo;
  const disableNossoNumero = disabledSubJudice || !!formik.values?.receitaCobranca?.nossoNumero;

  const getLabelNossoNumero = () => {
    return formik.values?.receitaCobranca?.nossoNumero ? 'Nosso número' : 'Nosso número antigo';
  };

  const getIdNossoNumero = () => {
    return formik.values?.receitaCobranca?.nossoNumero ? 'receitaCobranca.nossoNumero' : 'nossoNumeroAntigo';
  };

  const formikValues = formik?.values;
  useEffect(() => {
    formik.values.valorEmAberto = getValorEmAberto();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikValues]);

  const getSomatorioValorBrutoCategoriasList = () => {
    const valorBrutoSomatorio =
      formik.values?.categorias?.reduce((acc, item) => {
        return acc + item.valorBruto;
      }, 0) || 0;

    let valorEmAberto = valorBrutoSomatorio;
    return valorEmAberto;
  };

  const getValorEmAbertoParcelasAnteriores = () => {
    let baixas = formik?.values?.baixas;
    let valorEmAberto = 0;

    for (let i = 0; i < baixas?.length; i++) {
      const baixa = baixas[i];
      let correcoes =
        (baixa?.juros?.valorBruto || 0) +
        (baixa?.multa?.valorBruto || 0) +
        (baixa?.correcaoMonetaria?.valorBruto || 0) -
        (baixa?.desconto?.valorBruto || 0);
      valorEmAberto = valorEmAberto + correcoes - (baixa?.valorPago || 0);
    }

    return valorEmAberto;
  };

  const handleBaixarChange = (e) => {
    formik.handleChange(e);
    formik.setFieldValue('baixa.baixar', e?.target?.value === 'false');
  };

  function limitNossoNumero(val) {
    const maxLength = 11;
    if (val.length > maxLength) {
      val = val.substring(0, maxLength);
    }
    return val;
  }

  const getValorEmAberto = () => {
    const valorEmAberto =
      (getSomatorioValorBrutoCategoriasList() || 0) +
      (getValorEmAbertoParcelasAnteriores() || 0) -
      (formik.values?.baixa?.valorRecebido || 0);

    return valorEmAberto;
  };

  const exibirValorEmAberto = () => {
    let valorTotal = formik.values?.baixa?.valorRecebido || 0;
    if (formik?.values?.baixas?.length > 0) {
      for (let i = 0; i < formik?.values?.baixas?.length; i++) {
        if (formik?.values?.baixas[i]?.juros?.valorBruto) {
          valorTotal -= formik?.values?.baixas[i]?.juros?.valorBruto;
        }
        if (formik?.values?.baixas[i]?.multa?.valorBruto) {
          valorTotal -= formik?.values?.baixas[i]?.multa?.valorBruto;
        }
        if (formik?.values?.baixas[i]?.correcaoMonetaria?.valorBruto) {
          valorTotal -= formik?.values?.baixas[i]?.correcaoMonetaria?.valorBruto;
        }
        if (formik?.values?.baixas[i]?.desconto?.valorBruto) {
          valorTotal += formik?.values?.baixas[i]?.desconto?.valorBruto;
        }

        valorTotal += formik?.values?.baixas[i]?.valorPago || 0;
      }
    }
    return formik.values?.baixa && valorTotal !== getSomatorioValorBrutoCategoriasList();
  };

  const aplicarAcrescimos = (acrescimos) => {
    formik.handleChange({ target: { id: 'baixa.juros.valorBruto', value: acrescimos.valorJuros } });
    formik.handleChange({ target: { id: 'baixa.multa.valorBruto', value: acrescimos.valorMulta } });
    formik.handleChange({
      target: { id: 'baixa.correcaoMonetaria.valorBruto', value: acrescimos.valorCorrecaoMonetaria },
    });
  };

  const buscarAcrecimos = async (dataRecebimento) => {
    setLoading(true);
    try {
      const params = {
        valor: getSomatorioValorBrutoCategoriasList(),
        vencimento: moment(formik?.values?.dataVencimento).format('YYYY-MM-DD'),
        pagamento: dataRecebimento?.format('YYYY-MM-DD'),
      };

      const resp = await contaReceberApi.buscarAcrescimos(params);
      aplicarAcrescimos(resp.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeIncluirJurosMulta = (event) => {
    formik.handleChange(event);
    if (event?.target?.id?.includes('dataRecebimento')) {
      if (event.target.value && formik?.values?.baixa.acrescimoDesconto) {
        buscarAcrecimos(event?.target?.value);
      }
    } else if (event?.target?.id?.includes('acrescimoDesconto')) {
      if (!formik.values?.baixa?.acrescimoDesconto && formik?.values?.baixa?.dataRecebimento) {
        buscarAcrecimos(formik?.values?.baixa?.dataRecebimento);
      } else {
        formik.handleChange('baixa.juros', undefined);
        formik.handleChange('baixa.multa.valorBruto', undefined);
        formik.handleChange('baixa.correcaoMonetaria.valorBruto', undefined);
        formik.handleChange('baixa.desconto.valorBruto', undefined);
      }
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={sizes.competencia.xs}
        sm={sizes.competencia.sm}
        md={sizes.competencia.md}
        lg={sizes.competencia.lg}
        xl={sizes.competencia.xl}
      >
        <CompetenciaInput
          required
          fullWidth
          onBlur={formik.handleBlur}
          id="mesCompetencia"
          label="Mês Competência"
          value={formik.values?.mesCompetencia}
          onChange={formik.handleChange}
          touched={!!_errors.mesCompetencia}
          error={_errors.mesCompetencia}
          helperText={_errors.mesCompetencia}
          format="MM/YYYY"
          disabled={disabledSubJudice || disabledSeForOrigemContrato}
        />
      </Grid>
      <Grid
        item
        xs={sizes.cliente.xs}
        sm={sizes.cliente.sm}
        md={sizes.cliente.md}
        lg={sizes.cliente.lg}
        xl={sizes.cliente.xl}
      >
        <SelectClienteCreatable
          id="cliente"
          idObject="cliente"
          label="Cliente"
          autoFocus
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.cliente}
          touched={!!_errors.cliente}
          error={_errors.cliente}
          disabled={disabledSubJudice || disabledSeForOrigemContrato || disabledSeForOrigemVenda}
        />
      </Grid>
      {!isNovoCadastro && formik.values?.origemLancamento !== 'CONTA_RECEBER' && (
        <Grid
          item
          xs={sizes.origem.xs}
          sm={sizes.origem.sm}
          md={sizes.origem.md}
          lg={sizes.origem.lg}
          xl={sizes.origem.xl}
        >
          <TextLabel
            id="origemLancamento"
            label="Origem do lançamento"
            value={ORIGENS_LANCAMENTO[formik.values?.origemLancamento]}
          />
        </Grid>
      )}
      <ContasReceberCategorias
        exibirCalculo={false}
        values={formik.values || {}}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        touched={formik.touched?.categorias}
        errors={formik.errors?.categorias}
        disabled={disabledSubJudice || disabledSeForOrigemVenda}
        disabledCategoria={disabledSeForOrigemContrato}
        submitCount={formik.submitCount}
      />
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        <DateInput
          required
          fullWidth
          id="dataVencimento"
          label="Data do vencimento"
          value={formik.values?.dataVencimento}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={!!_errors.dataVencimento}
          error={_errors.dataVencimento}
          helperText={formik.errors?.dataVencimento}
          disabled={disabledSubJudice || disabledSeForOrigemVenda}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        {getLabelNossoNumero() === 'Nosso número antigo' ? (
          <HintTooltip
            title="Você pode informar o nosso número caso a conta tenha sido registrada anteriormente."
            placement="top"
          >
            <div>
              <NumberInput
                id={getIdNossoNumero()}
                label={getLabelNossoNumero()}
                fullWidth
                value={nossoNumero}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                format={limitNossoNumero}
                disabled={disableNossoNumero}
              />
            </div>
          </HintTooltip>
        ) : (
          <NumberInput
            id={getIdNossoNumero()}
            label={getLabelNossoNumero()}
            fullWidth
            value={nossoNumero}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            format={limitNossoNumero}
            disabled={disableNossoNumero}
          />
        )}
      </Grid>

      <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
        <SelectConta
          id="conta"
          fullWidth
          label="Conta"
          value={formik.values?.conta}
          onChange={(event) => {
            formik.handleChange(event);
          }}
          onBlur={formik.handleBlur}
          disabled={
            disabledSubJudice || disabledSeForOrigemContrato || disabledSeForOrigemVenda || disabledSeForBaixaParcial
          }
          required={
            formik.values?.baixa?.baixar ||
            (formik.values?.nossoNumero !== null && formik.values?.nossoNumero !== undefined) ||
            (formik.values?.nossoNumeroAntigo !== null && formik.values?.nossoNumeroAntigo !== undefined)
          }
          touched={!!_errors.conta}
          error={_errors.conta}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
        <TextInput
          id="documentoFiscal"
          label="Número do documento fiscal"
          fullWidth
          value={formik.values?.documentoFiscal}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled={disabledSeForOrigemContrato || disabledSeForOrigemVenda || disabledSeTiverNotaFiscalId}
          maxLength={15}
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        <DateInput
          fullWidth
          id="dataEmissao"
          label="Data de emissão"
          value={formik.values?.dataEmissao}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={!!_errors.dataEmissao}
          error={_errors.dataEmissao}
          helperText={formik.errors?.dataEmissao}
        />
      </Grid>
      {!isNovoCadastro && !origemConciliacao && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                id="subJudice"
                name="subJudice"
                value={formik.values?.subJudice}
                checked={formik.values.subJudice}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            }
            label="Conta a receber em sub judice"
          />
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="observacoes"
          label="Observações"
          fullWidth
          value={formik.values?.observacoes}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={500}
          multiline
          rows={5}
        />
      </Grid>

      {!origemConciliacao && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            label="Repetir lançamento"
            control={
              <Switch
                id="repetirLancamento"
                name="repetirLancamento"
                value={repetirLancamento}
                checked={repetirLancamento}
                color="primary"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.values?.id} // RNE-2332
              />
            }
          />
        </Grid>
      )}
      {repetirLancamento && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <span>{'As receitas regulares devem ser resgatadas periodicamente em Ações > Receitas regulares'}</span>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <ListaDeOcorrencia
              required
              id="recorrencia.frequencia"
              value={formik.values?.recorrencia?.frequencia}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={!!_errors.recorrencia?.frequencia}
              error={_errors.recorrencia?.frequencia}
              helperText={formik.errors?.recorrencia?.frequencia}
              disabled={formik.values?.id} // RNE-232
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <NumberInput
              required
              fullWidth
              label="Quantidade de ocorrências"
              id="recorrencia.quantidade"
              decimalScale={8}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(value) => {
                return !value.floatValue || value.floatValue <= 100;
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values?.recorrencia?.quantidade}
              touched={!!_errors.recorrencia?.quantidade}
              error={_errors.recorrencia?.quantidade}
              helperText={formik.errors?.recorrencia?.quantidade}
              disabled={formik.values?.id} // RNE-232
            />
          </Grid>
        </>
      )}

      {!origemConciliacao && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            label="Baixar"
            control={
              <Switch
                id="baixar"
                name="baixar"
                value={formik.values?.baixar}
                checked={formik.values?.baixar}
                color="primary"
                onChange={(e) => {
                  handleBaixarChange(e);

                  if ((getValorEmAbertoParcelasAnteriores() || 0) === 0) {
                    formik.setFieldValue('baixa.valorRecebido', getSomatorioValorBrutoCategoriasList());
                  } else {
                    formik.setFieldValue(
                      'baixa.valorRecebido',
                      getSomatorioValorBrutoCategoriasList() + getValorEmAbertoParcelasAnteriores()
                    );
                  }
                }}
                onBlur={formik.handleBlur}
                disabled={disabledSubJudice || disabledSeForOrigemContrato || disabledSeForOrigemVenda}
              />
            }
          />
        </Grid>
      )}
      {formik.values?.baixar && (
        <>
          <Grid item xs={6} sm={3}>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <InputLabel id="baixa.formaRecebimento" required shrink error={!!_errors.baixa.formaRecebimento}>
                Forma de recebimento
              </InputLabel>
              <Select
                id="baixa.formaRecebimento"
                name={'baixa.formaRecebimento'}
                label="Forma de recebimento"
                labelId="baixa.formaRecebimento"
                value={formik.values?.baixa?.formaRecebimento || null}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!_errors.baixa.formaRecebimento}
                helperText={_errors.baixa.formaRecebimento}
                notched
                fullWidth
                required
              >
                <MenuItem value="BOLETO">Boleto</MenuItem>
                <MenuItem value="CARTAO_CREDITO">Cartão de crédito</MenuItem>
                <MenuItem value="CARTAO_DEBITO">Cartão de débito</MenuItem>
                <MenuItem value="CHEQUE">Cheque</MenuItem>
                <MenuItem value="DINHEIRO">Dinheiro</MenuItem>
                <MenuItem value="TED_DOC">TED/DOC</MenuItem>
                <MenuItem value="PIX">PIX</MenuItem>
                <MenuItem value="OUTRAS">Outras</MenuItem>
              </Select>
              <FormHelperText style={{ color: '#f44336' }}>{_errors?.baixa?.formaRecebimento || ''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <DateInput
              autoFocus
              fullWidth
              required
              id="baixa.dataRecebimento"
              label="Data do recebimento"
              value={formik.values?.baixa?.dataRecebimento || null}
              onChange={handleChangeIncluirJurosMulta}
              onBlur={formik.handleBlur}
              disabled={disabledSubJudice}
              error={!!_errors.baixa.dataRecebimento}
              helperText={_errors.baixa.dataRecebimento}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <DateInput
              autoFocus
              fullWidth
              required
              id="baixa.dataLiquidacao"
              label="Data da liquidação"
              value={formik.values?.baixa?.dataLiquidacao || null}
              onChange={handleChangeIncluirJurosMulta}
              onBlur={formik.handleBlur}
              disabled={disabledSubJudice}
              error={!!_errors.baixa.dataLiquidacao}
              helperText={_errors.baixa.dataLiquidacao}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputMonetario
              fullWidth
              autoFocus
              required
              label="Valor (R$)"
              id="baixa.valorRecebido"
              name="baixa.valorRecebido"
              value={formik.values?.baixa?.valorRecebido}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={_errors.baixa.valorRecebido}
              touched={_errors.baixa.valorRecebido}
              helperText={_errors.baixa.valorRecebido}
              disabled={disabledSubJudice}
              maximumValue="999999999.99"
            />
          </Grid>
          {exibirValorEmAberto() && (
            <Grid item xs={12} sm={2}>
              <ReadOnlyInput
                fullWidth
                id="baixa.valorAberto"
                label="Valor em aberto (R$)"
                onBlur={formik.handleBlur}
                value={formik?.values?.valorEmAberto === 0 ? '-' : getCurrency(formik?.values?.valorEmAberto)}
                handleChange={formik.handleChange}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControlLabel
              label="Incluir acréscimos e descontos"
              control={
                <Switch
                  id="baixa.acrescimoDesconto"
                  name="baixa.acrescimoDesconto"
                  value={formik.values?.baixa?.acrescimoDesconto}
                  checked={formik.values?.baixa?.acrescimoDesconto}
                  color="primary"
                  onChange={handleChangeIncluirJurosMulta}
                  onBlur={formik.handleBlur}
                  disabled={disabledSubJudice}
                />
              }
            />
          </Grid>
          {formik.values?.baixa?.acrescimoDesconto && (
            <ContaReceberAcrescimosDescontos
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errors={formik.errors}
              touched={formik.touched}
              values={formik.values}
              disabled={disabledSubJudice}
            />
          )}
        </>
      )}
      {formik.values?.baixar && formik?.values?.valorEmAberto < 0 && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography style={{ fontSize: 15, fontWeight: 500, color: '#f00' }}>
            Diferença: {getCurrency(formik?.values?.valorEmAberto)}
          </Typography>
        </Grid>
      )}

      {formik?.values?.baixas && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ContaReceberRecebimentosRealizados
            showCancelarBaixa={true}
            baixas={formik?.values?.baixas}
            formik={formik}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ContaReceberForm;
